import * as React from 'react';
import { ArticleHeading1 } from '@cian/ui-kit';

import * as styles from './MortgageSection.css';

export interface IMortgageSectionProps extends React.PropsWithChildren {
  tabs?: React.ReactNode;
  title: string;
}

export const MortgageSection: React.FC<IMortgageSectionProps> = ({ children, tabs, title }) => {
  return (
    <div data-testid="MortgageSection">
      <div className={styles['title']}>
        <ArticleHeading1 as="h2" data-mark="MortgageSectionTitle">
          {title}
        </ArticleHeading1>
      </div>
      {tabs && <div className={styles['tabs']}>{tabs}</div>}
      {children}
    </div>
  );
};
